import styled from 'styled-components';

const P = styled.p`
  color: #666d71;
  display: block;
  font-size: 1.6em;
  margin: 10px 0 0 0;
  text-align: left;
`;

export default P;